var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"banner_section_1"},[_c('ul',{staticClass:"banner_box"},[_c('li',{directives:[{name:"bg",rawName:"v-bg"}],staticClass:"banner_item",attrs:{"bg-url":require("@/plan/assets/image/1/banner.jpg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }